// extracted by mini-css-extract-plugin
export default {"sectionHeading":"ReviewSummary-module__sectionHeading___20ipy","summaryContainer":"ReviewSummary-module__summaryContainer___2pGO_"};